import { images } from '../constants';

const team = [ 
    {
        id: 1,
        image: images.dorota,
        name: 'dr Dorota Mańkowska ',
        title: 'Przewodnicząca rady',
        biography: "W-ce Prezes Rady Ogrodów Botanicznych i Arboretów w Polsce, Członek Regionalnej Rady Ochrony Przyrody.",
        contacts: {
            email: 'dorota.man@onet.pl',
        },
    },
    {
        id: 2,
        image: images.m_kiedrzynski,
        name: 'dr hab. Marcin Kiedrzyński ',
        title: 'z-ca Przewodniczącej ',
        biography: 'Kierownik Katedry Biogeografii Paleoekologii i Ochrony Przyrody, Instytutu Ekologii i Ochrony Środowiska, Uniwersytetu Łódzkiego, Członek Zarządu Regionalnej Rady Ochrony Przyrody.' ,
        contacts: {
            email: 'marcin.kiedrzynski@biol.uni.lodz.pl',
        },
    },
    {
        id: 3,
        image: images.team3,
        name: 'prof. dr hab. Bożena Matysiak',
        title: 'Członek rady',
        biography: 'Z-ca Dyrektora ds. Naukowych Instytutu Ogrodnictwa - Państwowego Instytutu Badawczego w Skierniewicach, Prezes Polskiego Towarzystwa Różanego',
        contacts: {
            email: 'Bozena.Matysiak@inhort.pl',
        },
    },
    {
        id: 4,
        image: images.ressel,
        name: 'Katarzyna Ressel ',
        title: 'Członek rady',
        biography: 'Prezes Ogólnopolskiego Stowarzyszenia Twórców Ogrodów',
        contacts: {
            email: 'biuro.osto@gmail.com',
        },
    },
    {
        id: 5,
        image: images.l_rojewski,
        name: 'Łukasz Rojewski',
        title: 'Członek rady',
        biography: 'hodowca róż, Członek Klubu Hodowców przy Światowej Federacji Towarzystw Różanych, założyciel i pierwszy prezes Polskiego Towarzystwa Różanego.',
        contacts: {
            email: 'rojewski.biblio@gmail.com ',
        },
    },
    {
        id: 6,
        image: images.szymczak,
        name: 'inż. Jacek Szymczak',
        title: 'Członek rady',
        biography: 'Nadleśniczy Nadleśnictwa Kutno',
        contacts: {
            email: 'jacek.szymczak@lodz.lasy.gov.pl',
            phone: '24 356 73 75',
        },
    },
    {
        id: 7,
        image: images.team4,
        name: 'dr hab. inż. Ewa Zaraś',
        title: 'Członek rady',
        biography: 'Dziekan Wydziału Ogrodnictwa SGGW, Katedra Ochrony Środowiska i Dendrologii, Instytutu Nauk Ogrodniczych Szkoły Głównej Gospodarstwa Wiejskiego w Warszawie. ',
        contacts: {
            email: 'ewa_zaras@sggw.edu.pl',
        },
    },
    {
        id: 8,
        image: images.marta,
        name: 'dr Marta Znajmiecka',
        title: 'Członek rady',
        biography: 'Z-ca Dyrektora Instytutu Psychologii ds. dydaktycznych, Instytut Psychologii, Wydział Nauk o Wychowaniu, Uniwersytet Łódzki.',
        contacts: {
            email: 'marta.znajmiecka@now.uni.lodz.pl',
        },
    },
     {
        id: 9,
        image: images.marek_kubacki,
        name: 'inż. Marek Kubacki',
        title: 'Członek rady',
        biography: 'chirurg drzew, dendrolog, inżynier środowiska',
        contacts: {
            email: 'marek@chd.pl',
        },
    },
     {
        id: 10,
        image: images.d_sochacki,
        name: 'dr hab. inż. Dariusz Sochacki ',
        title: 'Członek rady',
        biography: 'Samodzielny Zakład Roślin Ozdobnych Instytutu Nauk Ogrodniczych, Szkoły Głównej Gospodarstwa Wiejskiego w Warszawie',
        contacts: {
            email: 'dariusz_sochacki@sggw.edu.pl',
            phone: '22 593 22 62',
        },
    },
    {
        id: 11,
        image: images.b_krolik,
        name: 'mgr inż Bogdan Królik',
        title: 'Członek rady',
        biography: 'Bogdan Królik – ogrodnik, kolekcjoner i jeden z największych w Polsce producentów roślin cebulowych oraz bylin. Od wielu lat zajmuje się ich uprawą, selekcją i popularyzacją, tworząc bogate kolekcje roślin ozdobnych. Jego działalność łączy praktyczne doświadczenie ogrodnicze z szerzeniem wiedzy o różnorodności i znaczeniu roślin cebulowych w ogrodach.',
        contacts: {
            email: '',
        }
    }
];

export default team;